import { styled } from '@mui/material/styles';

const Form = styled('form')({
  width: '100%',
});

export { Form };
